export enum ScreenBreakpoint {
  XL = 1920,
  LG = 1200,
  TABLET = 1024,
  MD = 992,
  SMALL_TABLET = 820,
  SM = 768,
  // xs < 768
  XS = 767,
}

export const screenSize = {
  [ScreenBreakpoint.XS]: 'xs',
  [ScreenBreakpoint.SM]: 'sm',
  [ScreenBreakpoint.SMALL_TABLET]: 'small-tablet',
  [ScreenBreakpoint.MD]: 'md',
  [ScreenBreakpoint.TABLET]: 'tablet',
  [ScreenBreakpoint.LG]: 'lg',
  [ScreenBreakpoint.XL]: 'xl',
}
